<template>
    <div class="location-map-component">
        <div class="flex">
            <div class="details-container" :class="{visible:selectedLocation}">
                <div class="details-box bg-white">
                    <div class="content" v-if="selectedLocation != null">
                        <div class="top-title" v-if="selectedLocation.top_title" v-html="selectedLocation.top_title"></div>
                        <h2 class="title" v-if="selectedLocation.title" v-html="selectedLocation.title"></h2>
                        <div class="copy" v-if="selectedLocation.copy" v-html="selectedLocation.copy"></div>
                        <div class="button-container" v-if="selectedLocation.button">
                            <a class="hover-button orange" :href="selectedLocation.button.url" :target="selectedLocation.button.target" v-html="selectedLocation.button.title"></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="map-container" ref="mapContainer" :class="{'details-visible': selectedLocation}">
                <slot name="map"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        locations: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            selectedLocationId: null
        }
    },
    mounted() {
        this.initalizeMap();
    },
    computed: {
        selectedLocation : function() {
            var location = null;
            if (this.selectedLocationId != null) {
                location = this.locations.find(obj => {
                    return obj.location == this.selectedLocationId;
                });
            }
            return location;
        }
    },
    methods: {
        initalizeMap() {
            let locations = this.$refs.mapContainer.getElementsByClassName('location');
            for (var i = 0; i<locations.length; i++) {
                locations[i].addEventListener('click', this.locationClicked);
            }
        },

        locationClicked(event) {
            let location = event.target.closest('.location').getAttribute('id');
            this.selectedLocationId = location;
        }
    }
}
</script>

<style>

</style>